import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'kx-offline-component',
    templateUrl: 'offline.component.html',
    standalone: false
})
export class OfflineComponent implements OnInit {
  public toHomePage;
  constructor(
    public router:Router
  ) { 
    this.toHomePage = ()=>{
      this.router.navigate([""]);
    }
  }

  ngOnInit(){
    window.addEventListener('online', this.toHomePage,true);
  }

  
  ngOnDestroy(){
    window.removeEventListener('online',this.toHomePage,true);
  }
}
